module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-5-1d7478f1615991f0be67f6f755ec4720.svg";